module.exports = __webpack_public_path__ + "img/组 1325@2x.d48936d6.png";